'use client';

import { P5BasicAppLoader } from '@repo-ui/code-project/p5-basic-app';

export default function Page() {
  return <P5BasicAppLoader />;
}
